import { render, staticRenderFns } from "./OfferTitleDescription.vue?vue&type=template&id=a1f7660a&scoped=true&"
import script from "./OfferTitleDescription.vue?vue&type=script&lang=js&"
export * from "./OfferTitleDescription.vue?vue&type=script&lang=js&"
import style0 from "./OfferTitleDescription.vue?vue&type=style&index=0&id=a1f7660a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f7660a",
  null
  
)

export default component.exports